import * as React from 'react';


import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import Badge from '@mui/material/Badge';


type Props = {
    label: string | null,
    title: string,
    items: object[] | string[] | null,
    display: ( x: object | string ) => string,
    badge: boolean
}

// TODO ajouter une option pour savoir comment gérer la valeur du badge ie sur une liste de 10 items : '10' ou '+9'

function MultipleItemsBadgeAndPopover({ label, title, items, display, badge } : Props) {

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
      };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    if(!items || items.length === 0)
    {
        return null;
    }
    
    // if(items.length === 1)
    // {
    //     return <>{label ? label : display(items[0] as object | string)}</>;
    // }

    return (
        <>
            <Box
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >            
                {badge && (
                    <Badge badgeContent={items.length - 1 ? `+${items.length - 1}` : 0} color="secondary">
                        <Box sx={{marginRight: '16px'}}>{label ? label : display(items[0] as object | string)}</Box>                                       
                    </Badge>  
                )}      
                {!badge && (
                    <Box sx={{marginRight: '16px'}}>{label ? label : display(items[0] as object | string)}</Box> 
                )}              
            </Box>

            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none',
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <List
                    subheader={
                        <ListSubheader
                            sx={{ bgcolor:'#778899'}}
                        >
                            {title}
                        </ListSubheader>}
                >
                    {items.map((item, index) => {
                        return (
                            <ListItem key={index}>
                                <ListItemText
                                    sx={{ whiteSpace: 'nowrap' }}
                                    primary={display(item)} />
                            </ListItem>
                        )
                    })}
                </List>
            </Popover>
        </>
    );
}



export default MultipleItemsBadgeAndPopover;